import i18next from "i18next"
import { bicycodeConfiguration } from "operators/bicycode/config"
import { decathlonConfiguration } from "operators/decathlon/config"
import { moustacheConfiguration } from "operators/moustache/config"
import { mfcConfiguration } from "operators/mfc/config"

export type UserDomainObject = {
	id: string
	value: number
	role: string
	label: string
}

export const ACCEPTED_NOTIFICATION = "accepted"

/**********************
 ***** Permissions *****
 **********************/
const PERMISSION_ADMIN_VALUE = 0
const PERMISSION_DEFAULT_VALUE = 1
export const userPermissionList: Array<{
	id: string
	value: number
	label: string
}> = [
	{ id: "admin", value: PERMISSION_DEFAULT_VALUE, label: "" },
	{ id: "individual", value: PERMISSION_ADMIN_VALUE, label: "" },
]

/**********************
 **** User Genders ****
 **********************/

// GENDERS
export const PRIVATE_GENDER_VALUE = 1
export const PRIVATE_GENDER_ID = "private-consumer"

export const COMPANY_GENDER_VALUE = 2
export const COMPANY_GENDER_ID = "company-consumer"

export const ADMIN_GENDER_VALUE = 9
export const ADMIN_GENDER_ID = "admin"

// CONSUMERS
export const privateConsumer: UserDomainObject = {
	id: PRIVATE_GENDER_ID,
	value: PRIVATE_GENDER_VALUE,
	role: PRIVATE_GENDER_ID,
	label: i18next.t("private", { ns: "user" }),
}

export const companyConsumer: UserDomainObject = {
	id: COMPANY_GENDER_ID,
	value: COMPANY_GENDER_VALUE,
	role: COMPANY_GENDER_ID,
	label: i18next.t("company", { ns: "user" }),
}

export const consumers: UserDomainObject[] = [privateConsumer, companyConsumer]
export const consumersGenders = consumers.map((consumer) => consumer.value)

// ADMIN
// FIXME: the is currently no admin on the platform
// export const admin: UserDomainObject = {
// 	id: ADMIN_GENDER_ID,
// 	value: ADMIN_GENDER_VALUE,
// 	role: ADMIN_GENDER_ID,
// 	label: i18next.t("admin", { ns: "user" }),
// }

// export const admins: UserDomainObject[] = [admin]
export const admins: UserDomainObject[] = []

// USERS
export const users: UserDomainObject[] = [...consumers, ...admins]

/**********************
 **** Utils functions ***
 **********************/

type CheckGenderFn = (props: { gender: string | number }) => boolean

export const checkIsConsumer: CheckGenderFn = ({ gender }) =>
	consumersGenders.includes(parseInt(gender as string) as number)

export const checkIsPrivateConsumer: CheckGenderFn = ({ gender }) =>
	(parseInt(gender as string) as number) === PRIVATE_GENDER_VALUE

export const checkIsCompanyConsumer: CheckGenderFn = ({ gender }) =>
	(parseInt(gender as string) as number) === COMPANY_GENDER_VALUE

export const checkIsAdmin: CheckGenderFn = ({ gender }) =>
	(parseInt(gender as string) as number) === ADMIN_GENDER_VALUE

/**********************
 ***** Operators ******
 **********************/
export interface ThemeInterface {
	primaryColor?: string,
	primaryColorHover?: string,
	primaryColorLigthen?: string,
	secondaryColor?: string
	secondaryColorLighten?: string,
	secondaryColorHover?: string,
	formBackgroundColor?: string
	insaleBike?: string,
	insaleBikeHover?: string,
	placeholderColor?: string,

	fontFamilyHeading?: string

	borderRadiusBase?: string
	borderRadiusL?: string
	borderRadiusXl?: string

	footerBackground?: string
}

export interface OperatorInterface {
	name: string,
	subDomain: string,
	id: string,
	url: string,
	cguUrl: string, // Url vers le document CGU
	legalNoticeUrl: string, // Url vers le document mentions légales
	privacyPolicyUrl: string, // Url vers le document CGU
	folderName: string,
	faqAccordionLength: number, // Nombre d'accordeon dans la FAQ
	theme: ThemeInterface // Liste des couleurs de l'opérateur
}

// Pour ajouter un nouvel opérateur, il faut lui créer un dossier opérateur avec un fichier de config.
// Bien l'ajouter ici dans la liste des opérateurs et en dessous dans "operatorsFolderName"
export const operators: OperatorInterface[] = [
    bicycodeConfiguration,
	decathlonConfiguration,
	moustacheConfiguration,
	mfcConfiguration
]

export const operatorsFolderName: string[] = [
	bicycodeConfiguration.folderName, decathlonConfiguration.folderName, moustacheConfiguration.folderName, mfcConfiguration.folderName
]